import React, { useEffect, useState } from 'react'
import EmbeddedTimetableSettings from './EmbeddedTimtableSettings'
import EmbeddedProductSettings from './EmbeddedProductSettings'
import EmbeddedTimetablePreview from './EmbeddedTimetablePreview'
import { Bag, Calendar, CreditCard } from 'react-bootstrap-icons'
import EmbeddedProductsPreview from './EmbeddedProductsPreview'
import axios from 'axios'
import { ApiConnectionString } from '../../../constants/ApiConntection'
import { useAuthContext } from '../../../hooks/useAuthContext'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function Embedded({ id,goToChangePlan }) {
  const [view, setView] = useState('main')
  const [isLoading, setIsLoading] = useState(true)
  const [embeddedAllowed, setEmbeddedAllowed] = useState(false)
  const { user } = useAuthContext()

  const handleSwitch = (target) => setView(target)

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/myclub/${id}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      )

      if (response.status == 200) {
        setEmbeddedAllowed(response.data.embeddedAllowed)
      }
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const renderContent = () => {
    switch (view) {
      case 'main':
        return (
          <div className="p-4">
            <h3 className="fw-bold mb-3">Embedded Widget Settings</h3>

            <p className="text-muted mb-4">
              Increase your visibility and seamlessly integrate your club profile
              with your own website. Choose whether to display your timetable or
              your products below.
            </p>

            <div className="row g-4">
              <div className="col-sm-12 col-lg-6">
                <div className="card shadow-sm h-100">
                  <div className="card-body d-flex flex-column align-items-center text-center">
                    <div className="mb-3 text-primary">
                      <Calendar className="fs-1" />
                    </div>
                    <h5 className="fw-bold mb-2">Display your club timetable</h5>
                    <p className="text-muted mb-3">
                      Show your timetable on your site so visitors can see what is on and book faster.
                    </p>

                    <div className="w-100 mb-3">
                      <EmbeddedTimetablePreview />
                    </div>

                    <button
                      className="btn btn-primary w-100 mt-auto"
                      onClick={() => handleSwitch('timetable')}
                    >
                      Go to Timetable Settings
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-6">
                <div className="card shadow-sm h-100">
                  <div className="card-body d-flex flex-column align-items-center text-center">
                    <div className="mb-3 text-primary">
                      <Bag className="fs-1" />
                    </div>
                    <h5 className="fw-bold mb-2">Showcase your products</h5>
                    <p className="text-muted mb-3">
                      List passes and items on your site with a live product display.
                    </p>

                    <EmbeddedProductsPreview />

                    <button
                      className="btn btn-primary w-100 mt-auto"
                      onClick={() => handleSwitch('product')}
                    >
                      Go to Product Settings
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )

      case 'timetable':
        return (
          <div>
            <button
              className="btn btn-outline-secondary mb-3"
              onClick={() => handleSwitch('main')}
            >
              Back
            </button>
            <EmbeddedTimetableSettings id={id} />
          </div>
        )

      case 'product':
        return (
          <div>
            <button
              className="btn btn-outline-secondary mb-3"
              onClick={() => handleSwitch('main')}
            >
              Back
            </button>
            <EmbeddedProductSettings id={id} />
          </div>
        )

      default:
        return null
    }
  }

  if (isLoading) {
    return (
      <div className="p-4 text-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (!embeddedAllowed) {
return (
  <div className="p-4 text-center">
    <h3 className="fw-bold mb-3">Embedding Not Available</h3>
    <p className="text-muted">
      Your current plan does not allow embedding your club page into your own website.
    </p>
    <p className="text-muted mb-5">
      If you update your plan, you will be able to use the embedded widgets.
    </p>

    <div className="container d-flex flex-column flex-md-row justify-content-center gap-4">

      <div className="card p-4 shadow-sm">
        <div className="fs-1 mb-3 text-primary"><Calendar /></div>
        <h5 className="fw-bold">Embed Your Live Timetable</h5>
        <ul className="text-start mt-3">
          <li>Visitors can view your timetable on your website</li>
          <li>All updates happen automatically</li>
        </ul>
      </div>

      <div className="card p-4 shadow-sm">
        <div className="fs-1 mb-3 text-primary"><CreditCard /></div>
        <h5 className="fw-bold">Embed Booking And Payments</h5>
        <ul className="text-start mt-3">
          <li>Users can book directly on your website</li>
          <li>Smoother payments for your members</li>
        </ul>
      </div>

    </div>

    <div className="mt-5">
      <button className="btn btn-info px-4 py-2 fw-bold text-white" onClick={goToChangePlan}>
        Update Plan To Unlock Embedding
      </button>
    </div>
  </div>
)

  }

  return <div>{renderContent()}</div>
}
